import { EBadgeType } from 'common/contracts';

export const getBadgeLabel = (badgeType: EBadgeType | 'both'): string => {
    if (badgeType === EBadgeType.RIBBON) return 'Ribbon';
    if (badgeType === EBadgeType.EMBLEM) return 'Emblem';
    return 'Badge';
};

export const getBadgePlaceholder = (badgeType: EBadgeType | 'both'): string => {
    if (badgeType === EBadgeType.RIBBON) return 'Select Ribbon Badge';
    if (badgeType === EBadgeType.EMBLEM) return 'Select Emblem Badge';
    return 'Select Badge';
};

export const shouldRenderBadge = (badgeType: EBadgeType | 'both' | undefined): boolean => {
    return (
        badgeType === EBadgeType.RIBBON ||
        badgeType === EBadgeType.EMBLEM ||
        badgeType === 'both'
    );
};

